import { AfterViewInit, ChangeDetectorRef, Directive, HostListener, OnDestroy, output, inject } from '@angular/core';
import {Router} from '@angular/router';
import {PlatformStorage} from '@app/core/tokens/platform-storage.token';
import {publicPages, staticPages} from '@app/shared/constants';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Subject} from 'rxjs';

@Directive({
  selector: '[appAuthLogout]',
  standalone: true,
})
export class AuthLogoutDirective implements AfterViewInit, OnDestroy {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly storage = inject(PlatformStorage);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly router = inject(Router);

  readonly publicPage = output<boolean>();
  readonly staticPage = output<boolean>();

  private readonly unsubscribe$ = new Subject<void>();
  private readonly accessTokenKey = 'pac';
  private isPublicRoute = false;
  private isStaticRoute = false;

  ngAfterViewInit(): void {
    this.isPublicRoute = this.isPublicPage(window.location.pathname);
    this.publicPage.emit(this.isPublicRoute);
    this.isStaticRoute = this.isStaticPage(window.location.pathname);
    this.staticPage.emit(this.isStaticRoute);
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(storageEvent: StorageEvent) {
    if (storageEvent.storageArea === localStorage && storageEvent.oldValue !== storageEvent.newValue) {
      this.oidcSecurityService.isAuthenticated().subscribe(isAuthenticated => {
        if (
          !isAuthenticated &&
          !this.isPublicPage(window.location.pathname) &&
          !this.isStaticPage(window.location.pathname)
        )
          this.router.navigate(['/auth/logout']);
      });
    }
  }

  private isPublicPage(currentPath: string): boolean {
    return publicPages.includes(currentPath);
  }

  private isStaticPage(currentPath: string): boolean {
    return staticPages.includes(currentPath);
  }
}
